__turbopack_context__.v({
  "cls1": "IlluAnalyse-module__gPOt1q__cls1",
  "cls2": "IlluAnalyse-module__gPOt1q__cls2",
  "cls3": "IlluAnalyse-module__gPOt1q__cls3",
  "cls4": "IlluAnalyse-module__gPOt1q__cls4",
  "cls5": "IlluAnalyse-module__gPOt1q__cls5",
});
